<template>
  <a-form ref="formRef" layout="vertical" :model="formState">
    <RequiredField v-model:required="formState.required" />

    <a-form-item label="Texto del campo" name="label" required>
      <a-input v-model:value="formState.label" placeholder="Escribir texto del campo" />
      <p class="info">Escriba aquí su pregunta</p>
    </a-form-item>

    <a-form-item label="Validación" name="validation" required>
      <a-select
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        v-model:value="formState.validation"
        placeholder="Escribir texto del campo"
      >
        <a-select-option :value="ValidationType.TextAndNumber">Texto y número</a-select-option>
        <a-select-option :value="ValidationType.Text">Texto</a-select-option>
        <a-select-option :value="ValidationType.Number">Número</a-select-option>
        <a-select-option :value="ValidationType.Email">Correo</a-select-option>
      </a-select>
      <p class="info">Compruebe si la entrada coincide con el formato seleccionado.</p>
    </a-form-item>

    <a-form-item label="Instrucciones">
      <a-input v-model:value="formState.instruction" placeholder="Escribir instrucciones" />
      <p class="info">Añada una pequeña descripción debajo del campo de entrada</p>
    </a-form-item>
  </a-form>

  <div class="reminder">
    <p class="title"><strong>Recuerda</strong></p>

    <p class="description">
      La respuesta del usuario podrá tener un <strong>máximo de 70 caracteres</strong>. Si necesitas
      que se registe una respuesta más larga, puedes usar el elemento de Texto largo.
    </p>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref } from "vue";
import type { FormInstance } from "ant-design-vue";

import {
  ElementType,
  FormElementMap,
  FormStateElementMap,
  ValidationType,
} from "@/@types/entities/forms";

import RequiredField from "@/app/entities/components/drawers/forms/settings/fields/RequiredField.vue";

const props = defineProps<{
  input: FormElementMap[ElementType.ShortText];
}>();

const formRef = ref<FormInstance | undefined>(undefined);

const formState: FormStateElementMap[ElementType.ShortText] = reactive({
  label: props.input.label,
  instruction: props.input.instruction,
  required: props.input.required,
  validation: props.input.validation,
});

defineExpose({ formRef, formState });
</script>

<style scoped lang="sass">
p
  margin: 0

.ant-form-item-label
  padding: 0

.info
  color: $gray-7

.reminder
  & > p
    color: $gray-9

  .description
    color: $gray-7
    font-style: italic
    font-weight: 300
</style>
